import React from "react";
import LmsForm from "./LmsForm";
import Dropdown from "./Dropdown";
import DateBox from "./DateBox";
import Textarea from "./Textarea";
import InputBox from "./InputBox";

const WfhForm = ({
	handleSubmit,
	handleWfhStartDate,
	handleWfhEndDate,
	handleWfhAreaValue,
	wfhDescription,
	wfhTotalLeave,
	handleWfhType,
	wfhStartDate,
	wfhEndDate,
	wfhType,
	typeOptions,
}) => {
	return (
		<LmsForm
			style="mb-6"
			onSubmit={handleSubmit}
			labelOne="Start"
			itemOne={
				<DateBox
					required={true}
					style="w-full"
					value={wfhStartDate}
					onChange={handleWfhStartDate}
				/>
			}
			labelTwo="End"
			itemTwo={
				<DateBox
					required={true}
					style="w-full"
					value={wfhEndDate}
					onChange={handleWfhEndDate}
				/>
			}
			labelThree="Type"
			itemThree={
				<Dropdown
					style="w-full"
					value={wfhType}
					onChange={handleWfhType}
					options={typeOptions}
					required={true}
				/>
			}
			labelFour="No of Days"
			itemFour={
				<InputBox
					style="w-full"
					value={wfhTotalLeave}
					placeholder="No of days"
					disabled="disabled"
				/>
			}
			labelFive="Description"
			itemFive={
				<Textarea
					required={true}
					style="w-full h-32"
					value={wfhDescription}
					onChange={handleWfhAreaValue}
				/>
			}
			Submit="Submit"
		/>
	);
};

export default WfhForm;